import { ActionContext } from 'vuex'
import apiAdminUniteMobile from '@/api/admin/uniteMobile'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IUniteMobileState } from './state';
import { ApiResultCode } from '@/models/response/AlrBase';
import { AloDbUniteMobile } from '@/models/alodb/AloDbUniteMobile';
import { AloError } from '@/models/alo/AloError';
import { AloBaseArray } from '@/models/alo/AloBaseArray';
import { router } from '@/mainjs.js'
import {i18n} from '@/locale/vueI18n'

export class UniteMobileAction {
   
  public [types.UNITEMOBILE_REQUEST](context: ActionContext<IUniteMobileState, IRootState>) {    
    return new Promise((resolve, reject) => {
        context.commit(types.UNITEMOBILE_REQUEST)
        apiAdminUniteMobile
          .getUniteMobiles()
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const uniteMobileArray = resp.data.data as AloBaseArray<AloDbUniteMobile>
              context.commit(types.UNITEMOBILE_SUCCESS, uniteMobileArray.items)
              resolve(uniteMobileArray.items)
            } else {
              context.commit(types.UNITEMOBILE_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.UNITEMOBILE_ERROR)
            reject()
          })
      })
  }

  public [types.UNITEMOBILE_ENSURE_LIST](context: ActionContext<IUniteMobileState, IRootState>) {
    if(context.state.uniteMobiles.length == 0) {
        return context.dispatch(types.UNITEMOBILE_REQUEST)
    }
    else {
        return new Promise((resolve, reject) => {            
            resolve(context.state.uniteMobiles)            
        })
    }    
  }

  public [types.UNITEMOBILE_SELECT_DETAIL](context: ActionContext<IUniteMobileState, IRootState>, itemId:number) {        
    return new Promise((resolve, reject) => {
      const uniteMobile = context.getters.uniteMobilesById[itemId] as AloDbUniteMobile      
      if(uniteMobile) {        
        if(uniteMobile.detailLoaded) {
          context.commit(types.UNITEMOBILE_SELECT_DETAIL,uniteMobile)
          resolve(uniteMobile)
        }
        else{
          context.dispatch(types.UNITEMOBILE_SELECT_DETAIL_REQUEST,itemId).then((ens) => {
            context.commit(types.UNITEMOBILE_SELECT_DETAIL,ens)
            resolve(ens)
          })
        }
      }    
      else{
        const newUniteMobile = new AloDbUniteMobile()
        context.commit(types.UNITEMOBILE_SELECT_DETAIL,newUniteMobile)
        resolve(newUniteMobile)
      }
    })
  }

  public [types.UNITEMOBILE_SELECT_DETAIL_REQUEST](context: ActionContext<IUniteMobileState, IRootState>, itemId:number) {
    return new Promise((resolve, reject) => {
        context.commit(types.UNITEMOBILE_SELECT_DETAIL_REQUEST, itemId)
        apiAdminUniteMobile
          .getUniteMobile(itemId)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const uniteMobile = resp.data.data as AloDbUniteMobile
              context.commit(types.UNITEMOBILE_SELECT_DETAIL_SUCCESS, uniteMobile)
              context.commit(types.UNITEMOBILE_SELECT_DETAIL,uniteMobile)
              resolve(uniteMobile)
            } else {
              context.commit(types.UNITEMOBILE_SELECT_DETAIL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            context.commit(types.UNITEMOBILE_SELECT_DETAIL_ERROR)
            reject()
          })
      })
  }

  public [types.UNITEMOBILE_SAVE_REQUEST](context: ActionContext<IUniteMobileState, IRootState>) {    
    return new Promise((resolve, reject) => { 
        const tryRedirect = !context.state.modifiedAdmUniteMobile.id
        context.commit(types.UNITEMOBILE_SAVE_REQUEST,context.state.modifiedAdmUniteMobile.UMB_LIBELLE)
        apiAdminUniteMobile
          .saveUniteMobile(context.state.modifiedAdmUniteMobile)                    
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const uniteMobile = resp.data.data as AloDbUniteMobile            
              context.commit(types.UNITEMOBILE_SELECT_DETAIL_SUCCESS, uniteMobile)
              context.commit(types.UNITEMOBILE_SELECT_DETAIL,uniteMobile)               
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:uniteMobile.UMB_LIBELLE}))
              if(tryRedirect && router.app.$route.name === 'NewUniteMobile') router.push({name:'EditUniteMobile',params:{uniteMobileid:uniteMobile.id!.toString()}})
              resolve(uniteMobile)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.UNITEMOBILE_SAVE_ERROR)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))              
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.UNITEMOBILE_SAVE_ERROR)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
              reject()
            }            
          })
      })
  }

  public [types.UNITEMOBILE_UPDATE_MODIFIED_ADM](context: ActionContext<IUniteMobileState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.UNITEMOBILE_UPDATE_MODIFIED_ADM,newProperties)
      resolve(context.state.modifiedAdmUniteMobile)
    })
  }
  
  public [types.UNITEMOBILE_CANCEL_MODIFIED_ADM](context: ActionContext<IUniteMobileState, IRootState>) {        
    return new Promise((resolve, reject) => {
      context.commit(types.UNITEMOBILE_SELECT_DETAIL,context.state.originalAdmUniteMobile)
      resolve(context.state.modifiedAdmUniteMobile)
    })
  }

  public [types.UNITEMOBILE_UPDATE_FILTER_ADM](context: ActionContext<IUniteMobileState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.UNITEMOBILE_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }
  
  
}

export default util.classToObject(UniteMobileAction)